export const getPlatformName = (platform_id) => {
    // Convert the platform_id to a number to handle both string and number inputs
    const id = Number(platform_id);
  
    switch (id) {
      case 1:
        return 'Google';
      case 2:
        return 'Linkedin';
      case 3:
        return 'Snapchat';
      case 4:
        return 'Spotify';
      case 5:
          return 'Google Analytics';
      case 6:
            return 'Facebook';
      case 7:
        return 'Instagram';
      default:
        return '---';
    }
  }


  export const getPlatformNameOrId = (input) => {
    // Define a mapping of IDs to platform names
    const platformMap = {
      1: 'Google',
      2: 'Linkedin',
      3: 'Snapchat',
      4: 'Spotify',
      5: 'Google Analytics',
      6: 'Facebook',
      7: 'Instagram',
    };
    let nameToId=""
    if(input!=undefined)
    {
      const id = Number(input);
  
      if (platformMap[id]) return platformMap[id];
    
       nameToId = Object.entries(platformMap).find(([key, value]) => 
        value?.toLowerCase() === input?.toLowerCase()
      );

    }

  
  
    return nameToId ? Number(nameToId[0]) : '---';
  };

  export const getRedirectionURL=(platform_id,media_type)=>{
    try{

      let platform_name=getPlatformNameOrId(platform_id)
     
      if(platform_name==='Google Analytics')
      {
        return '/client/settings/analytics'
      }
 
      if(media_type==='paid_social')
      {

        return '/client/settings/link-ads'
      }
      if(media_type==='organic_social')
        {
          return '/client/settings/link-organic-social'
        }



    }
    catch(e)
    {
      console.log(e)
    }
  }
  